import React, { useEffect, useState } from "react";

const ProductActionSection = ({
  t,
  demoTabs,
  activeDemo,
  setActiveDemo,
  activeTab,
}) => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    setVideoLoaded(false);
  }, [activeTab?.id]);

  return (
    <section className="product-action dark-gradient-section anim-section home-section" id="producto">
      <div className="home-container">
        <div className="section-head">
          <h2>{t.productAction.head}</h2>
          <p>{t.productAction.sub}</p>
        </div>
        <div className="tabs">
          {demoTabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${activeDemo === tab.id ? "active" : ""}`}
              type="button"
              onClick={() => setActiveDemo(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="tab-panel">
          <div className="tab-copy">
            <h3>{activeTab?.title}</h3>
            <p>{activeTab?.text}</p>
            <ul>
              {activeTab?.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
            <button className="btn btn-outline" type="button" onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}>
              {t.buttons.verTourCompleto}
            </button>
          </div>
          <div className="tab-visual">
            <div className="panel-preview card-animated anim-card">
              <div className="panel-header">
                <span>{activeTab?.label}</span>
                <span>{t.productAction.vista}</span>
              </div>
              <div className="panel-body">
                {activeTab?.videoBase ? (
                  <>
                    {!videoLoaded && (
                      <div className="panel-skeleton" aria-hidden="true">
                        <div className="panel-line" />
                        <div className="panel-line short" />
                        <div className="panel-line" />
                        <div className="panel-line short" />
                        <div className="panel-line" />
                      </div>
                    )}
                    <video
                      key={activeTab.id}
                      className="panel-video"
                      autoPlay
                      loop
                      muted
                      playsInline
                      controls={false}
                      preload="auto"
                      poster={`${activeTab.videoBase}.jpg`}
                      style={{ opacity: videoLoaded ? 1 : 0, background: "#eaf3ff" }}
                      onLoadedData={() => setVideoLoaded(true)}
                    >
                      <source src={`${activeTab.videoBase}.webm`} type="video/webm" />
                      <source src={`${activeTab.videoBase}.mp4`} type="video/mp4" />
                    </video>
                  </>
                ) : (
                  <>
                    <div className="panel-line" />
                    <div className="panel-line short" />
                    <div className="panel-line" />
                    <div className="panel-line short" />
                    <div className="panel-line" />
                  </>
                )}
              </div>
            </div>
            <div className="panel-metrics">
              <div className="card-animated anim-card">
                <strong>{t.productAction.infra}</strong>
                <span>{t.productAction.precision}</span>
              </div>
              <div className="card-animated anim-card">
                <strong>99.9%</strong>
                <span>{t.productAction.latencia}</span>
              </div>
              <div className="card-animated anim-card">
                <strong>24/7 </strong>
                <span>{t.productAction.soporte}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductActionSection;
